import React, { Component, useState } from 'react';
import { PropTypes } from 'prop-types';
import LanguageTabs from '../../Tabs/LanguageTabs';
import LanguageTab from '../../Tabs/LanguageTab';
import languages from '../../../utils/languages';
//const languages = ['en', 'es', 'ca', 'pt'];

const StructureLanguageTabs = ({ children }, style) => {
  const [activeLanguage, setActiveLanguage] = useState('en');

  const handlerActiveLanguage = (e) => {
    const { name } = e.target.dataset;
    setActiveLanguage(name);
  };


  const tabs = languages.map(lang => (
    <span
      key={lang}
      className={`tab pl-5 flex items-center cursor-pointer font-semibold text-xs rounded-t ${activeLanguage === lang.toLowerCase() && (style ? 'active-white' : 'active')}`}
      data-name={lang.toLowerCase()}
      onClick={handlerActiveLanguage}
    >
      {lang}
    </span>
  ));


  return (
    <div className="text-white language-tabs w-full">
      <div className="flex w-full">
        {tabs}
      </div>
      {children(activeLanguage, languages)}
    </div>
  );
};

StructureLanguageTabs.propTypes = {
  children: PropTypes.func.isRequired,
  style: PropTypes.bool,
};

StructureLanguageTabs.defaultProps = {
  style: false,
};

export default StructureLanguageTabs;
